import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Line"], {
    data: $setup.data,
    options: $setup.options
  }, null, 8, ["data", "options"]))
}